'use strict';
angular.module('appMarketplace')
    .controller('AuthCtrl', ['$scope', 'AuthService', 'UrlService', 'NotificationService', 'HelpService', 'CommonService',
                            '$location', '$state', '$window', function ($scope, AuthService, UrlService, NotificationService,
                                                                        HelpService, CommonService, $location, $state, $window) {
        $scope.releasePage = HelpService.getReleasePageUrl();
        $scope.init = function () {
            var container = angular.element("#flip-container");
            CommonService.showProgressPanel(container, false);

            $scope.user = {
                login: null,
                password: null,
                accountId: null,
                secret: null
            };

            $scope.dataLoaded = false;
            $scope.loginInput = angular.element("#login");
            $scope.passwordInput = angular.element("#password");
            $scope.secretInput = angular.element("#secret");
            $scope.effect = kendo.fx("#flip-container").flipHorizontal(angular.element("#frontSide"), angular.element("#flipSide")).duration(1000);
            $scope.reverse = false;
            $scope.profileSelectionMode = false;
            focusLoginInput();

            AuthService.getStatus(function successCallback(data) {
                if (data.authenticated) {
                    $scope.profileSelectionMode = true;
                    $scope.buildProfilesList(data.profiles);
                }
                CommonService.hideProgressPanel(container);
                $scope.dataLoaded = true;
            }, function errorCallback(responseError) {
                NotificationService.showValidationErrors(responseError);
                CommonService.hideProgressPanel(container);
                $scope.dataLoaded = true;
            });

            switch ($location.url()) {
                case "/logout":
                    NotificationService.showSuccessMessage("You have logged out of the system.");
                    $state.go('root-state');
                    break;
                case "/expired":
                    NotificationService.showErrorMessage("Your session has expired. Please login again to continue.");
                    $state.go('root-state');
                    break;
            }
        }();

        /**
         * Sets focus on login input after flip animation is completed
         */
        function focusLoginInput() {
            if (window.navigator.appVersion.indexOf("MSIE 9.") !== -1) { //workaround for IE9
                $scope.loginInput.focus();
            } else {
                angular.element(".flipper")
                    .on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", function onAnimationEnd() {
                        $scope.loginInput.focus();
                    });
            }
        }

        $scope.flipWindow = function () {
            $scope.effect.stop();
            $scope.reverse ? $scope.effect.reverse() : $scope.effect.play();
            $scope.reverse = !$scope.reverse;
        };

        $scope.shakeElement = function (input) {
            input.siblings().andSelf().effect("shake", {distance: 10});
        };

        $scope.loginSuccessful = function () {
            $window.location.replace(UrlService.createAbsoluteUrl('/welcome.jsp'));
        };

        $scope.buildProfilesList = function (profiles) {
            $scope.user.profiles = profiles;
            $scope.user.accountId = profiles[0].id;
            angular.element("#profileSelect").kendoDropDownList({
                dataTextField: "orgName",
                dataValueField: "id",
                dataSource: profiles,
                template: kendo.template(angular.element("#profileSelectTemplate").html()),
                index: 0
            });
        };

        $scope.doLogin = function () {
            $scope.passwordLookupDone = false;

            if ($scope.loginForm.$invalid || $scope.performingLogin) {
                if (!$scope.user.login) {
                    $scope.shakeElement($scope.loginInput);
                }

                if (!$scope.user.password) {
                    $scope.shakeElement($scope.passwordInput);
                }
                return;
            }

            $scope.performingLogin = true;
            NotificationService.hideNotifications();

            AuthService.login($scope.user.login, $scope.user.password, $scope.user.accountId,
                function successCallback(data) {
                    if (!data.loggedIn) {
                        $scope.buildProfilesList(data.profiles);
                        $scope.performingLogin = false;
                        $scope.flipWindow();
                    } else {
                        $scope.loginSuccessful();
                    }
                },
                function errorCallback(responseError) {
                    NotificationService.showValidationErrors(responseError);
                    $scope.performingLogin = false;
                });
        };

        $scope.doSelectAccount = function () {
            $scope.performingLogin = true;
            NotificationService.hideNotifications();

            AuthService.login($scope.user.login, $scope.user.password, $scope.user.accountId,
                $scope.loginSuccessful,
                function errorCallback(responseError) {
                    NotificationService.showValidationErrors(responseError);
                    $scope.performingLogin = false;
                    $scope.flipWindow();
                });
        };

        $scope.getSecretQuestion = function () {
            if (!$scope.user.login) {
                $scope.shakeElement($scope.loginInput);
                return;
            }
            $scope.flipWindow();
            $scope.passwordLookupDone = false;
            $scope.user.secret = null;
            $scope.user.profiles = null;
            $scope.secretQuestion = null;
            AuthService.getSecretQuestion($scope.user.login,
                function successCallback(data) {
                    $scope.secretQuestion = data;
                },
                function errorCallback(responseError) {
                    NotificationService.showValidationErrors(responseError);
                    $scope.flipWindow();
                });
        };

        $scope.passwordLookup = function () {
            if (!$scope.user.secret) {
                $scope.shakeElement($scope.secretInput);
                return;
            }
            AuthService.passwordLookup($scope.user.login, $scope.user.secret,
                function successCallback() {
                    $scope.passwordLookupDone = true;
                },
                function errorCallback(responseError) {
                    NotificationService.showValidationErrors(responseError);
                });
        };
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/controllers/auth-ctrl.js
// module id = 212
// module chunks = 36